import { initialState } from '@/store'


export default {
  commit_mainMetric (state, value) {
    state.metric = value
  },
  commit_newFilters (state, obj) {
    state.globalFilters = obj
  },
  commit_initCleanStates (state) {
    state.globalFilters = ''
    state.selectedView = ''
    state.selectedWeek = {}
  },
  commit_selectedWeek (state, array) {
    state.selectedWeek.index = array[0]
    state.selectedWeek.category = array[1]
  },
  commit_selectedView (state, view) {
    state.selectedView = view
  },
  commit_selectedYear (state, year) {
    state.selectedWeek.year = year
  },
  commit_selectedMetricOption (state, id) {
    state.selectedMetricOption = id
  },
  commit_appAvailableHeight (state, value) {
    state.appAvailableHeight = value - 1
  },
  reset_app (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
    localStorage.removeItem('accessToken')
  },
  setDesktopParameterConfig (state, desktopParameterConfig) {
    state.desktopParameterConfig = desktopParameterConfig
  },
  setActiveWorkspace (state, workspace) {
    state.desktopParameterConfig.activeWorkspace = workspace
  },
  setDashboardRangeOption (state, dashboardRangeOption) {
    state.selectedRangeOption = dashboardRangeOption
  },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js